import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { Button, SectionHeader, Link } from 'user/components';
import { Spinner } from 'components/Spinner/spinner';
import { OverlayBackground } from './styles';
import { useAppContext } from 'hooks/useContext';

export const FreecodeLoading = ({ loading, errors, errorLink, errorLinkText, signInRequired = false }) => {
  const { isInitialized, userRole } = useSelector((state) => state.auth);
  const [loadingError, setLoadingError] = useState(undefined);

  const { isDarkMode } = useAppContext();

  useEffect(() => {
    if (!isInitialized) return;
    let newLoadingErrors = [];
    if (signInRequired && !userRole) newLoadingErrors.push('Sign in to access this page');
    for (const error of errors) {
      if (error) {
        newLoadingErrors.push(error?.message || (typeof error === 'string' ? error : 'An unknown error occured!'));
      }
    }
    if (newLoadingErrors.length) {
      setLoadingError(newLoadingErrors.join(', '));
    }
  }, [errors, isInitialized, userRole, signInRequired]);

  const renderLoading = () => <Spinner title="Loading Freecode Editor"></Spinner>;

  const renderError = () => (
    <OverlayBackground>
      <SectionHeader lightColor={isDarkMode}>{loadingError}</SectionHeader>
      <Link to={errorLink}>
        <Button primary border>
          {errorLinkText}
        </Button>
      </Link>
    </OverlayBackground>
  );

  return (
    <>
      {loading && !loadingError && !isInitialized && renderLoading()}
      {loadingError && renderError()}
    </>
  );
};
